import React from "react";
import { calculateProjectDurationFlexible } from "../../../../../utils/sharedFunctions";

const AtoZ = `${process.env.REACT_APP_CDN_URL}/globalAssets/A-ZFilter.svg`;
const ZtoA = `${process.env.REACT_APP_CDN_URL}/globalAssets/Z-AFilter.svg`;

const AvailableBriefsTable = ({
  AvailBriefs,
  MonthFilter,
  OfferingFilter,
  ServiceCategoryFilter,
  FulfillmentLeadFilter,
  ContractTypeFilter,
  JobStatusFilter,
  BriefPayment2Open,
  handleTitleFilterComps,
  handleGotoPreview,
  handlerPaymentEnter,
  handlePaymentLeave,
  formatCash,
  processQuote,
  financialCalculations,
  getDaysDifference,
  formatDate,
}) => {
  if (!Array.isArray(AvailBriefs)) {
    return (
      <div className="briefSect">
        <p style={{ color: "var(--red-orange)", textAlign: "center" }}>
          No data available!
        </p>
      </div>
    );
  }

  const getNextPaymentDetails = (quote) => {
    if (!quote) return { date: null, amount: 0, label: "N/A" };

    const today = new Date();
    today.setHours(0, 0, 0, 0); 

    const depositDate = quote.depositDueDate ? new Date(quote.depositDueDate) : null;
    const secondDate = quote.secondPaymentDueDate ? new Date(quote.secondPaymentDueDate) : null;
    const finalDate = quote.finalPaymentDueDate ? new Date(quote.finalPaymentDueDate) : null;

    if (depositDate && depositDate >= today) {
      return { date: quote.depositDueDate, amount: quote.deposit, label: "Deposit" };
    }
    if (secondDate && secondDate >= today) {
      return { date: quote.secondPaymentDueDate, amount: quote.secondPayment, label: "2nd Payment" };
    }
    if (finalDate) {
      return { date: quote.finalPaymentDueDate, amount: quote.finalPayment, label: "Final" };
    }
    return { date: null, amount: 0, label: "Completed" };
  };

  const renderHeader = () => (
    <div className="availProjectsHeaderContainer">
      <p style={{ minWidth: "200px" }}>Client Name</p>
      <p style={{ minWidth: "200px" }}>Job Number</p>
      <div className="monthFilterSection" style={{ cursor: "pointer" }}>
        <p id="month" onClick={handleTitleFilterComps}>Month</p>
        <img src={MonthFilter === "A-Z" ? AtoZ : ZtoA} id="Month" onClick={handleTitleFilterComps} alt="filter" />
      </div>
      <p style={{ minWidth: "200px" }}>Project Name</p>
      <div className="offeringFilterSection">
        <p onClick={handleTitleFilterComps} id="offering">Offering</p>
        <img src={OfferingFilter === "A-Z" ? AtoZ : ZtoA} id="Offering" onClick={handleTitleFilterComps} alt="filter" />
      </div>
      <div className="serviceCategoryFilterSection">
        <p id="serviceCategory" onClick={handleTitleFilterComps}>Service Category</p>
        <img src={ServiceCategoryFilter === "A-Z" ? AtoZ : ZtoA} id="ServiceCategory" onClick={handleTitleFilterComps} alt="filter" />
      </div>
      <p style={{ minWidth: "200px" }}>Service Provider(s)</p>
      <p style={{ minWidth: "200px" }}>No. of Professionals</p>
      <div className="fulfillmentLeadFilterSection">
        <p id="fulfilmentLead" onClick={handleTitleFilterComps}>Fulfillment Lead</p>
        <img src={FulfillmentLeadFilter === "A-Z" ? AtoZ : ZtoA} id="FulfillmentLead" onClick={handleTitleFilterComps} alt="filter" />
      </div>
      <div className="contractTypeFilterSection">
        <p id="contractType" onClick={handleTitleFilterComps}>Contract Type</p>
        <img src={ContractTypeFilter === "A-Z" ? AtoZ : ZtoA} id="ContractType" onClick={handleTitleFilterComps} alt="filter" />
      </div>
      <p style={{ minWidth: "200px" }}>Contract Signed</p>
      
      <p style={{ minWidth: "200px" }}>Job Amount</p>
      <p style={{ minWidth: "200px" }}>Professional Fees</p>
      
      <p style={{ minWidth: "200px" }}>Credipple Fee</p>
      <p style={{ minWidth: "200px" }}>Contract Duration</p>
      <p style={{ minWidth: "200px" }}>Invoice Number(s)</p>
      <p style={{ minWidth: "200px" }}>Purchase Order</p>
      <p style={{ minWidth: "200px" }}>Voucher ID</p>
      <div className="jobStatusFilterSection">
        <p id="jpbStatus" onClick={handleTitleFilterComps}>Job Status</p>
        <img src={JobStatusFilter === "A-Z" ? AtoZ : ZtoA} id="JobStatus" onClick={handleTitleFilterComps} alt="filter" />
      </div>
      <p style={{ minWidth: "200px" }}>Project Start Date</p>
      <p style={{ minWidth: "200px" }}>Fulfillment Stage</p>
      <p style={{ minWidth: "250px" }}>Payment Milestone</p>
      <p style={{ minWidth: "450px" }}>Milestone Payment for Weekly Payment Runs (Yes/No)</p>
      <p style={{ minWidth: "200px" }}>Next Payment Date</p>
      <p style={{ minWidth: "200px" }}>Next Payment Amount</p>
      <p style={{ minWidth: "400px" }}>Credipple Fees Withheld for Professionals (Pre)</p>
      <p style={{ minWidth: "250px" }}>Project Payments Made</p>
      <p style={{ minWidth: "200px" }}>Evaluation completed</p>
      <p style={{ minWidth: "250px" }}>Customer experience rating %</p>
      <p style={{ minWidth: "300px" }}>Credipple Fees for Professionals (Post)</p>
      <p style={{ minWidth: "200px" }}>Account Balance</p>
      <p style={{ minWidth: "200px" }}>Project End Date</p>
      <p style={{ minWidth: "200px" }}>Project Duration</p>
    </div>
  );

  const renderRow = (item, index) => {
    // 1. Check if Migrated to prevent crashes
    const isMigrated = item?.isMigrated === true;

    const proName = isMigrated 
        ? (item.staticValues?.professionalName || "N/A")
        : (item?.professional?.firstName ? `${item.professional.firstName} ${item.professional.lastName || ''}` : "Unassigned");
    
    // For live items, we need a valid professional ID.
    if (!isMigrated && !item?.professional?._id) return null;

    const pro = item.professional || {};
    
    const processedQuote = processQuote(item.brief, pro); 
    const Finance = financialCalculations(processedQuote.totalPayable, item.brief);

    const quote = (!isMigrated && Array.isArray(item?.brief?.quote) && item.brief.quote.length > 0) 
      ? item.brief.quote[0] 
      : null;
console.log(quote)
    // 4. Calculate Next Payment Dynamically
    const nextPayment = getNextPaymentDetails(quote);

    return (
      <div className="briefCArd" key={index} onClick={() => handleGotoPreview(item)} style={{ cursor: "pointer" }}>
        
        {/* Client Name */}
        <p style={{ overflow: "hidden", minWidth: "195px", maxWidth: "200px" }}>
            {isMigrated ? item.staticValues?.clientName : `${item?.client?.firstName ?? ""} ${item?.client?.lastName ?? ""}`}
        </p>

        {/* Job Number */}
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>{item?.referenceNumber ?? "N/A"}</p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>{formatDate(item?.createdAt) ?? "N/A"}</p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>{item?.title ?? "N/A"}</p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          {Array.isArray(item?.servicesOffered) ? item.servicesOffered[item.servicesOffered.length - 1] : item?.servicesOffered ?? "N/A"}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          {Array.isArray(item?.serviceCategory) ? item.serviceCategory[item.serviceCategory.length - 1] : item?.serviceCategory ?? "N/A"}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>{proName}</p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
             {isMigrated ? (item.staticValues?.noOfProfessionals ?? 1) : (pro?.firstName ? 1 : 0)}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
            {isMigrated ? (item.staticValues?.fulfillmentLeadName) : `${item?.fullfilmentLead?.firstName ?? ""} ${item?.fullfilmentLead?.lastName ?? ""}`}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>{item?.contractType ?? "N/A"}</p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          {isMigrated 
            ? (item.brief?.contractSigned || "NO") 
            : (Array.isArray(item?.brief?.documents) && item?.brief?.documents.length > 0 ? (item?.brief?.documents[0].acceptedBy?.length > 1 ? "Yes" : "No") : "No")
          }
        </p>

        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          ZAR {formatCash(isMigrated ? item.staticValues?.jobAmount : (processedQuote.totalPayable + processedQuote.totalPayable * 0.12)) ?? 0}
        </p>
        
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          ZAR {formatCash(isMigrated ? item.staticValues?.professionalFees : processedQuote.totalPayable) ?? 0}
        </p>
        
        {/* Credipple Fee */}
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          ZAR {formatCash(isMigrated ? item.staticValues?.credippleFee : quote?.credippleClientFee) ?? 0}
        </p>
        
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          {isMigrated 
            ? (item.staticValues?.contractDuration ?? "N/A") 
            : `${getDaysDifference(formatDate(item?.brief?.projectPlan?.[0]?.projStartDate), formatDate(item?.brief?.projectPlan?.[0]?.projEndDate))} days`
          }
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
          {isMigrated 
             ? (item.staticValues?.invoiceNumber || "N/A")
             : (item?.payments?.invoiceNumbers?.filter((e) => e !== "").join(", ") || "No invoices available")}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
             {isMigrated ? item.staticValues?.purchaseOrder : (item?.payments?.puechaseOrder ?? "N/A")}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
             {isMigrated ? item.staticValues?.voucherID : (item?.voucherNumber ?? "N/A")}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>{item?.status?.toLowerCase() ?? "N/A"}</p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
             {formatDate(isMigrated ? item.startDate : item?.brief?.projectPlan?.[0]?.projStartDate) ?? "N/A"}
        </p>
        <p style={{ overflow: "hidden", minWidth: "200px", maxWidth: "200px" }}>
             {isMigrated ? "Brief" : (item?.brief?.projectPlan?.[0]?.fulfillmentStage ?? "N/A")}
        </p>
        <p style={{ overflow: "hidden", minWidth: "250px", maxWidth: "200px" }}>
            {quote?.milestone ?? "N/A"}
        </p>
        <p style={{ overflow: "hidden", minWidth: "450px", maxWidth: "200px" }}>
          {(item?.contractType && item.contractType.toLowerCase().includes("once")) ? "Yes" : "No"}
        </p>

        <p className="nextPaymentcover" id={index} onMouseEnter={handlerPaymentEnter} onMouseLeave={handlePaymentLeave}>
          
          {Number(BriefPayment2Open) === index && quote && (
            <div className="paymentHover">
              {/* 1. Deposit */}
              <p style={{ width: "98%", display: "flex", flexDirection: "row", fontSize: "14px", margin: "1px 0px", height: "25%", justifyContent: "flex-start", alignItems: "center" }}>
                <span style={{ width: "51%" }}>{formatDate(quote.depositDueDate) ?? "N/A"}</span>
                <span style={{ width: "48%" }}>{Number(quote.deposit) > 0 ? `ZAR ${formatCash(quote.deposit)}` : "N/A"}</span>
              </p>

              {/* 2. Second Payment */}
              {quote.selectedPaymentPlan !== "2(50/50)" && (
                <p style={{ width: "98%", display: "flex", flexDirection: "row", fontSize: "14px", margin: "1px 0px", height: "25%", justifyContent: "flex-start", alignItems: "center" }}>
                  <span style={{ width: "51%" }}>{formatDate(quote.secondPaymentDueDate) ?? "N/A"}</span>
                  <span style={{ width: "48%" }}>{Number(quote.secondPayment) > 0 ? `ZAR ${formatCash(quote.secondPayment)}` : "N/A"}</span>
                </p>
              )}

              {/* 3. Final Payment */}
              <p style={{ width: "98%", display: "flex", flexDirection: "row", fontSize: "14px", margin: "1px 0px", height: "25%", justifyContent: "flex-start", alignItems: "center" }}>
                <span style={{ width: "51%" }}>{formatDate(quote.finalPaymentDueDate) ?? "N/A"}</span>
                <span style={{ width: "48%" }}>{Number(quote.finalPayment) > 0 ? `ZAR ${formatCash(quote.finalPayment)}` : "N/A"}</span>
              </p>
            </div>
          )}

          {/*  (Calculated Next Payment) */}
          <p style={{ minWidth: "49%" }}>
            {isMigrated ? "N/A" : (nextPayment.date ? formatDate(nextPayment.date) : "N/A")}
          </p>
          <p style={{ minWidth: "49%" }}>
            {isMigrated 
                ? `ZAR ${formatCash(item.staticValues?.nextPaymentAmount || 0)}` 
                : (nextPayment.amount > 0 ? `ZAR ${formatCash(nextPayment.amount)}` : "N/A")
            }
          </p>
        </p>
        
        <p style={{ minWidth: "400px" }}>{`ZAR ${
          item?.evaluation?.clientEvaluation?.client_summary?.credipple_rating && item?.evaluation?.clientEvaluation?.client_summary?.credipple_rating > 79
            ? formatCash(Finance.CredFee10 * 0.5)
            : formatCash(Finance.CredFee10)
        }`}</p>
        <p style={{ minWidth: "250px" }}>{item?.payments?.invoiceNumbers?.filter((e) => e !== "").length ?? 0}</p>
        <p style={{ minWidth: "200px" }}>{item?.evaluation?.professionalEvaluation?.state === "completed" ? "YES" : "NO"}</p>
        <p style={{ minWidth: "250px" }}>
          {item?.evaluation?.clientEvaluation?.client_summary?.credipple_rating ? `${item.evaluation.clientEvaluation.client_summary.credipple_rating}%` : "0%"}
        </p>
        <p style={{ minWidth: "300px" }}>{item?.finance?.credippleFeesForProfessional ?? "N/A"}</p>
        <p style={{ minWidth: "200px" }}>{`ZAR ${formatCash(isMigrated ? item.staticValues?.accountBalance : (Finance.Remaining2BPayByClient || 0))}`}</p>
        <p style={{ minWidth: "200px" }}>{formatDate(item?.endDate) ?? "N/A"}</p>
        <p style={{ minWidth: "200px" }}>
             {isMigrated 
                ? item.staticValues?.contractDuration 
                : calculateProjectDurationFlexible(item?.brief?.projectPlan?.[0]?.projStartDate, item?.endDate)
             }
        </p>
      </div>
    );
  };

  return (
    <div className="briefSect">
      {renderHeader()}
      <div className="availProjectsBodyContainer">
        {AvailBriefs.map(renderRow)}
      </div>
    </div>
  );
};

export default AvailableBriefsTable;